<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة مدير</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/managerview">مديرين الموقع</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة مدير</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-clipboard-plus ps-2 text-brown"></i> أضافة المدير
            </h5>
            <div class="card shadow mb-4">
              <div class="text-center pt-3">
                <errorAlert v-if="hasError" :alertMessage= "message" />
              </div>
              <div v-if="successAdmin" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <form action="" @submit.prevent="createAdmin">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>الاسم:</label>
                        <input type="text" class="form-control" v-model="name" placeholder="الاسم" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>البريد الإلكتروني:</label>
                        <input
                          type="email"
                          class="form-control"
                          v-model="email"
                          placeholder="البريد الإلكتروني"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>كلمة المرور:</label>
                        <input
                          type="password"
                          class="form-control"
                          v-model="password"
                          placeholder="كلمة المرور"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>رقم الجوال <span v-if="isAccountManager" class="text-danger">*</span><span v-else>(اختياري)</span>:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="mobileNumber"
                          :required="isAccountManager"
                          placeholder="05xxxxxxxx"
                        />
                        <div v-if="isAccountManager" class="form-text">
                          رقم الجوال مطلوب لأن هذا الحساب مُفعّل كمدير حساب.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="form-check-label" for="userIsAdmin">يمتلك جميع الصلاحيات (Super User)</label>
                        <select class="form-control" v-model="isAdmin">
                          <option :value="true">نعم</option>
                          <option :value="false">لا</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-check py-2">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="isAccountManagerCheck"
                          v-model="isAccountManager"
                        />
                        <label class="form-check-label" for="isAccountManagerCheck">
                          تفعيل هذا الحساب كمدير حساب أيضاً 
                        </label>
                        <div class="form-text">
                          هذا الحساب سيبقى مديراً في اللوحة، وسيظهر أيضاً في قائمة مديرين الحسابات ليتم تعيينه للعملاء.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-check py-2">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="isApprovalOfficerCheck"
                          v-model="isApprovalOfficer"
                        />
                        <label class="form-check-label" for="isApprovalOfficerCheck">
                          مسؤول تعميد
                        </label>
                        <div class="form-text">يمكنه تعميد أو رفض الطلبات وإسنادها للموظفين التنفيذيين.</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-check py-2">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="isExecutiveEmployeeCheck"
                          v-model="isExecutiveEmployee"
                        />
                        <label class="form-check-label" for="isExecutiveEmployeeCheck">
                          موظف تنفيذي
                        </label>
                        <div class="form-text">يظهر في الإسناد لتنفيذ تركيب اللوحات وأعمال الصيانة والتسويق.</div>
                      </div>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col">
                      <label for="">المجموعات</label>
                      <select class="form-control" v-model="groups" multiple>
                        <option v-for="group in groupsList" :value="group.id" :key="group.id">{{ group.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label for="">الحاله</label>
                        <select class="form-control" v-model="status">
                          <option :value="true">نشط</option>
                          <option :value="false">غير نشط</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <img v-if="loading" src="/assets/img/minLoader.gif" class="w-50" alt="">
                  <button v-else type="submit" class="btn btn-success">
                    إرسال
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name: "manager",
  data(){
    return {
      loading: true,
      hasError: false,
      successAdmin: false,
      message: "",
      name: "",
      email: "",
      password: "",
      status: true,
      isAdmin: false,
      groups: [],
      groupsList: [],
      mobileNumber: "",
      isAccountManager: false,
      isApprovalOfficer: false,
      isExecutiveEmployee: false,
    }
  },
  methods:{
    resetData(){
      this.name = "";
      this.email = "";
      this.password = "";
      this.isAdmin = false;
      this.groups = [];
      this.mobileNumber = "";
      this.isAccountManager = false;
      this.isApprovalOfficer = false;
      this.isExecutiveEmployee = false;
    },
    getGroupsList(){
      this.$http.get(`/api/admin/groups/list?all=1`).then(({data}) => {
        this.groupsList = data.groups;
        this.loading = false;
      }).catch(err => {
        this.message = 'يوجد خطأ في المجموعات';
      });
    },
    createAdmin() {
      this.hasError = false;

      if (this.isAccountManager && !this.mobileNumber.trim()) {
        this.hasError = true;
        this.message = 'رقم الجوال مطلوب عند اختيار الحساب كمدير حساب';
        window.scroll(0,0);
        return;
      }

      this.loading = true;
      this.$http.post('/api/admin/admins/create',{
        name: this.name,
        email: this.email,
        password: this.password,
        isActive: this.status,
        isSuperUser: this.isAdmin,
        groups: JSON.stringify(this.groups),
        mobileNumber: this.mobileNumber,
        isAccountManager: this.isAccountManager,
        isApprovalOfficer: this.isApprovalOfficer,
        isExecutiveEmployee: this.isExecutiveEmployee,
      }).then(res => {
        this.message = 'تم الاضافة بنجاح'
        this.successAdmin = true;
        // this.name = "";
        // this.email = "";
        // this.password = "";
        this.loading = false;
        this.resetData();
        window.scroll(0,0);
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.loading = false;
        window.scroll(0,0);
      })
    }
  },
  created(){
    this.getGroupsList();
  }
};
</script>